import React, { Fragment, useState, useEffect } from "react";
import Multiselect from "multiselect-react-dropdown";
import { getApi } from "../../api/endpoints.js";
import VehicleInspectionItem from "../../models/VehicleInspectionItem.js";
import InspectionItem from "../../models/InspectionItem.js";

const VehiclesForm = (props) => {
  const { setVehicleInspectionItems, setAllInspectionItems } = props;
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [inspectionItemsApi] = getApi('inspectionItems');
  const [vehicleTypesApi] = getApi('vehicleTypes');

  useEffect(() => {
    fetchOptions(vehicleTypesApi, "vehicle_types", { fields: "options" }, setVehicleTypes);
  }, [])

  const fetchOptions = async (api, key, params = {}, setFunction) => {
    try {
      const response = await api(params).unwrap();
      if(key == "inspection_items") {
        let vehicleInspectionItemObj = new VehicleInspectionItem({vehicle_type_id: response.data[key][0]["vehicle_type_id"], inspection_items:[...response.data[key]]});
        setFunction(vehicleInspectionItemObj)
      } else if (key == "inspection_items_all") {
        let allItems = response.data["inspection_items"].map((item) => new InspectionItem(item));
        setFunction(allItems)
      } else {
        setFunction(response.data[key])
      }
    } catch (error) {
    }
  }

  const onMultiSelectSelect = (key, selectedItem, array_key = false) => {
    fetchOptions(inspectionItemsApi, "inspection_items", { vehicle_type_id: selectedItem.id }, setVehicleInspectionItems)
    fetchOptions(inspectionItemsApi, "inspection_items_all", { for_picker: true }, setAllInspectionItems)
  }

  const onMultiSelectRemove = () => {
    setVehicleInspectionItems([]);
    setAllInspectionItems([]);
  }
  

  return <Fragment>
    <form className="col-md-3 my-2" autoComplete="off">
      <label htmlFor='vehicle_type_id' className="form-label mb-1">Select Vehicle Type</label>
      <Multiselect
        // selectedValues={props.selectedValues}
        options={vehicleTypes}
        onSelect={(selectedList, selectedItem) => onMultiSelectSelect("vehicle_type_id", selectedItem)}
        onRemove={(selectedList, removedItem) => onMultiSelectRemove("vehicle_type_id", removedItem)}
        placeholder='Select Vehicle Type'
        displayValue={'type'}
        showArrow={true}
        customArrow={true}
        selectionLimit={1}
        avoidHighlightFirstOption={true}
      />
    </form>
  </Fragment>
}

export default VehiclesForm;
